const highBloodPressureType = {
  No: 1,
  BorderlineHigh: 2,
  High: 3
}

export default highBloodPressureType;